import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { map, concatMap } from 'rxjs/operators';
import { OrigamiUrlsParams } from '@app/origami-api/constants';
import { SessionService } from '@app/session/session.service';
import { of } from 'rxjs';
import { AppRoutes } from '@app/app-routes';

@Injectable({
  providedIn: 'root',
})
export class NoAccessModuleGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private sessionService: SessionService,
  ) {}

  canActivate = (route: ActivatedRouteSnapshot) => {
    return this.authService.checkSession().pipe(
      concatMap((authRes) => {
        if (!authRes.error && !!authRes.info && !!authRes.info.SessionId && !authRes.info.RegistrationMode) {
          if (authRes.info.HasAccessToAnyRoom) {
            return of({ loggedOut: false, hasAccessToRooms: true });
          }
          return this.sessionService.enterDomain().pipe(map(() => ({ loggedOut: false, hasAccessToRooms: false })));
        }
        return of({ loggedOut: true, hasAccessToRooms: false });
      }),
      map((res) => {
        this.goToAlterUrl({
          loggedOut: res.loggedOut,
          hasAccessToRooms: res.hasAccessToRooms,
          url: route.url.join('/'),
        });

        return !res.loggedOut && !res.hasAccessToRooms;
      }),
    );
  };

  canLoad = () =>
    this.authService.checkSession().pipe(
      map((auth) => {
        const loggedOut = !auth.hasSession || auth.registrationMode;
        const hasAccessToRooms = !!auth.info && auth.info.HasAccessToAnyRoom;

        this.goToAlterUrl({
          loggedOut: loggedOut,
          hasAccessToRooms: hasAccessToRooms,
        });

        return !loggedOut && !hasAccessToRooms;
      }),
    );

  canDeactivate = () => this.sessionService.leaveDomain().pipe(map(() => true));

  private goToAlterUrl(opt: { loggedOut: boolean; hasAccessToRooms: boolean; url?: string }) {
    if (opt.loggedOut) {
      const queryParams = opt.url ? { [OrigamiUrlsParams.returnRoute]: escape(opt.url) } : {};
      this.router.navigate(['/auth'], { queryParams: queryParams });
    } else if (opt.hasAccessToRooms) {
      this.router.navigate([AppRoutes.Main]);
    }
  }
}
